import { render, staticRenderFns } from "./EmailVerificationModal.vue?vue&type=template&id=998215a4&scoped=true"
import script from "./EmailVerificationModal.vue?vue&type=script&lang=js"
export * from "./EmailVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationModal.vue?vue&type=style&index=0&id=998215a4&prod&lang=scss&scoped=true"
import style1 from "./EmailVerificationModal.vue?vue&type=style&index=1&id=998215a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998215a4",
  null
  
)

export default component.exports